import './GoogleSearchPreview.less';
import React from 'react';
import SectionCompetitorResults from '../../shared/SectionCompetitorResults';
import SectionTitle from '../../shared/SectionTitle';
import SectionTooltip from '../../shared/SectionTooltip';
import { SectionProps } from '../../types';

export default function GooglePreviewSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className="report-element default"
        >
            <SectionTitle title={title} />

            <div className="report-element-description">
                <PreviewResult
                    url={result.url}
                    title={result.title}
                    description={result.description}
                />

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) => (
                            <PreviewResult
                                url={result.url}
                                title={result.title}
                                description={result.description}
                            />
                        )}
                        hideMessage={true}
                        hideUrl={true}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type PreviewResultProps = {
    url: string;
    title: string;
    description: string;
};

function PreviewResult({ url, title, description }: PreviewResultProps) {
    return (
        <div>
            <span className="stats-title">Desktop version</span>
            <div className="google-search-preview desktop">
                <span className="url-format">{url}</span>
                <span className="title-format line-clamp lines1">{title}</span>
                <span className="description-format line-clamp lines2">{description}</span>
            </div>

            <span className="stats-title">Mobile version</span>
            <div className="google-search-preview mobile">
                <span className="url-format">{url}</span>
                <span className="title-format line-clamp lines2">{title}</span>
                <span className="description-format line-clamp lines3">{description}</span>
            </div>
        </div>
    );
}
